/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {VelocityComponent, VelocityTransitionGroup} from 'velocity-react';
import ScrollArea from '../../../../ScrollArea';
import DivLoader from '../../../../DivLoader';
import Ratings from '../Ratings';
import Persons from '../Persons';

import {FetchAssetById} from '../../../../../actions/asset/action-asset';
import {OpenMessage, SetPlayer, SetSettingsState} from '../../../../../actions/common/actions-common';

import _get from 'lodash/get';

class Episode extends Component {
  constructor(props) {
    super(props);

    this.enterAnimation = {
      translateY: '0px'
    };

    this.leaveAnimation = {
       translateY: '270px'
    };

    this.state = {
      isPlayerShowed: false,
      picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`
    };
  }

  componentDidMount() {

    _get(this.props, 'episodeId', null) && this._fetchEpisodeAssetData(_get(this.props, 'episodeId', null));

    if (this.props.episode.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.episode, {
          crop: {x: 185, y: 270},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });
    }
  }

  componentWillReceiveProps(newProps) {
    let newState = {};

    if (this.props.episodeId !== newProps.episodeId && newProps.episodeId) {

      newState = {...newState, ...{
        picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
        streamCategory: null
      }};

      this._fetchEpisodeAssetData(_get(newProps, 'episodeId', null));
    }

    if (newProps.episode.id && newProps.episode.id !== this.props.episode.id) {

      lh.models.asset.methods
        .getPosterUrl(newProps.episode, {
          crop: {x: 185, y: 270},
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: Config.white_skin ? '' : `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });
    }

    if (newProps.playerIsDetached) {

      newState.isPlayerShowed = false;
    }

    this.setState(newState);
  }

  componentWillUnmount() {

    this.props.onStopPlayback();
  }

  _fetchEpisodeAssetData(episodeId) {
    this.props.FetchAssetById(episodeId, 'episode');

  };

  render() {

    return (
      <VelocityTransitionGroup enter={{animation: this.enterAnimation, duration: 350}} leave={{animation: this.leaveAnimation, duration: 150}}>
        { this.props.episodeId && <div className="episode-inf-profile bg-black">
          <DivLoader loading={this.props.inProgress} />
          <VelocityComponent animation={{left: this.props.isPlayerShowed ? '271px' : 0}} duration={500}>
            <div className="profile-cols relative">
              <div className="block-2 relative">
                <div className="profile-poster slider-pause">
                  <div className="hover crow no-gutter pointer" onClick={this.props.onStartPlayback.bind(this, this.props.episode, 'vod_hls')}>
                    <img id="profile_poster" src={this.state.picture} alt="" />
                    <img src={`/images/${Config.white_skin ? 'white' : 'black'}/play.png`} style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-30px', marginLeft: '-70px'}} />
                  </div>
                </div>
                <div className="player-back hover crow no-gutter"
                     style={{display: this.props.isPlayerShowed ? 'block' : 'none'}}
                     onClick={this.props.onStopPlayback.bind(this)}>
                  <i className="ic ic-chevron-left"></i>
                </div>
              </div>
              <div className="block-2 bg-black">
                <div className="close-down-episode hover" onClick={this.props.onClose}> <i className="ic ic-chevron-down ic-14px"></i> </div>

                <div className="profile-descr pr">
                  <div className="profile-title">
                    {_get(this.props.episode, 'title', '')}
                  </div>
                  <Ratings ratings={this.props.episode.ratings} />
                  <ScrollArea
                    speed={0.8}
                    className="profile-text"
                    horizontal={false}
                    smoothScrolling={true}>
                    <div>
                      {_get(this.props.episode, 'description', '')}
                      <Persons persons={this.props.episode.persons} />
                    </div>
                  </ScrollArea>
                </div>
              </div>
            </div>
          </VelocityComponent>
        </div>
        }
      </VelocityTransitionGroup>
    );
  }
}

Episode.propTypes = {
  episodeId: PropTypes.number,
  isPlayerShowed: PropTypes.bool,
  onStopPlayback: PropTypes.func,
  onStartPlayback: PropTypes.func,
  onClose: PropTypes.func,
  /**
   * From Store
   */
  episode: PropTypes.object,
  user: PropTypes.object,
  inProgress: PropTypes.bool
};

const mapStateToProps = ({assets, auth: {user}, common: {player}}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'episodeId', null), {});

  return {
    episode: asset,
    user,
    inProgress: !!asset._fetchInProgress,
    playerIsDetached: !!player.isDetached
  };
};

const mapDispatchToProp = (dispatch) => {

  return bindActionCreators({FetchAssetById, OpenMessage, SetPlayer, SetSettingsState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProp)(Episode);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Episode/episode.js